module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "lightgrey_bg",
    attrs: {
      "id": "features"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main_title mt_wave a_center"
  }, [_c('h2', {
    directives: [{
      name: "lang",
      rawName: "v-lang.our_awesome_services",
      modifiers: {
        "our_awesome_services": true
      }
    }]
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "lang",
      rawName: "v-lang.our_awesome_services_description",
      modifiers: {
        "our_awesome_services_description": true
      }
    }],
    staticClass: "main_description a_center"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [(_vm.selected != null) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "id": "img_service",
      "alt": "",
      "src": _vm.selected.src
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "owl-thumbs",
    attrs: {
      "data-slider-id": "features"
    }
  }, _vm._l((_vm.services), function(service, index) {
    return _c('owl-item', {
      key: "service.id",
      attrs: {
        "service": service,
        "index": index
      },
      on: {
        "change": _vm.disableOthers
      }
    })
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fe3b4b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/services/Services.vue
// module id = 372
// module chunks = 0